import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import '../../Pages/Homepage.css';
import Navbar from '../../commonComponents/Navbar';
import Footer from '../../commonComponents/Footer';
// import ConnectForm from '../../Componentsss/Contactus/ConnectForm/ConnectForm.jsx';
import GovernmentTravelBanner from '../../Componentsss/GovernmentTravel/GovernmentTravelBanner/GovernmentTravelBanner';
import GovMidBanner from '../../Componentsss/GovernmentTravel/GovMidBanner/GovMidBanner.jsx';
import GovCustomerService from '../../Componentsss/GovernmentTravel/GovCustomerService/GovCustomerService.jsx';
import GovSideCards from '../../Componentsss/GovernmentTravel/GovSideCards/GovSideCards.jsx';
const index = () => {
    return (
        <>
            <Navbar />
            <GovernmentTravelBanner />
            <GovMidBanner />
            <GovCustomerService />
            <GovSideCards />
            {/* <ConnectForm /> */}
            <Footer />
        </>
    )
}

export default index